module.exports = "function renderList (props) {\n  const { sortOrder, ...rest } = props\n\n  return (\n    <List\n      {...rest}\n      sortOrder={sortOrder}\n    />\n  );\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/pass-through-props.js
 ** module id = 374
 ** module chunks = 0
 **/